export const FOOTER_LINK = "https://www.igd.fraunhofer.de/de/branchen/software.html";
export const EMAIL_LINK = "transparencyvis@igd.fraunhofer.de";
